/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { AggiornaModuloRequest } from '../schemas/aggiornaModuloRequest.ts';
import type { AggiornaModuloResponse } from '../schemas/aggiornaModuloResponse.ts';
import type { AggiungiAllegatoResult } from '../schemas/aggiungiAllegatoResult.ts';
import type { AllegatoRichiestaDTO } from '../schemas/allegatoRichiestaDTO.ts';
import type { AnnullaDelegaRequest } from '../schemas/annullaDelegaRequest.ts';
import type { AnnullaDelegaResponse } from '../schemas/annullaDelegaResponse.ts';
import type { AvviaEBolloRequest } from '../schemas/avviaEBolloRequest.ts';
import type { AvviaPagamentoOnlineRequest } from '../schemas/avviaPagamentoOnlineRequest.ts';
import type { CambiamentoStatoRequest } from '../schemas/cambiamentoStatoRequest.ts';
import type { CampoEstraibileCSV } from '../schemas/campoEstraibileCSV.ts';
import type { CampoSemantico } from '../schemas/campoSemantico.ts';
import type { CollegamentoRichiestaDTO } from '../schemas/collegamentoRichiestaDTO.ts';
import type { Competenza } from '../schemas/competenza.ts';
import type { CreatePagamentoOneriRequest } from '../schemas/createPagamentoOneriRequest.ts';
import type { DelegaModulo } from '../schemas/delegaModulo.ts';
import type { DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams } from '../schemas/deleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams.ts';
import type { ElencoFileDocumento } from '../schemas/elencoFileDocumento.ts';
import type { EsitoValidazioneRichiestaDTO } from '../schemas/esitoValidazioneRichiestaDTO.ts';
import type { GetFrontRichiesteEstraiCampiSemanticiParams } from '../schemas/getFrontRichiesteEstraiCampiSemanticiParams.ts';
import type { GetFrontRichiesteIdCollegamentiParams } from '../schemas/getFrontRichiesteIdCollegamentiParams.ts';
import type { GetFrontRichiesteIdCompetenzeSecondarieParams } from '../schemas/getFrontRichiesteIdCompetenzeSecondarieParams.ts';
import type { GetFrontRichiesteIdDatiAggiuntiviRiepilogo200 } from '../schemas/getFrontRichiesteIdDatiAggiuntiviRiepilogo200.ts';
import type { GetFrontRichiesteIdModuliIdParams } from '../schemas/getFrontRichiesteIdModuliIdParams.ts';
import type { GetFrontRichiesteIdModuliIdSezioniIdFileCodiceParams } from '../schemas/getFrontRichiesteIdModuliIdSezioniIdFileCodiceParams.ts';
import type { GetFrontRichiesteIdModuliParams } from '../schemas/getFrontRichiesteIdModuliParams.ts';
import type { GetFrontRichiesteIdProcuratoreParams } from '../schemas/getFrontRichiesteIdProcuratoreParams.ts';
import type { GetFrontRichiesteParams } from '../schemas/getFrontRichiesteParams.ts';
import type { GetFrontRichiesteProcedimentoIdParams } from '../schemas/getFrontRichiesteProcedimentoIdParams.ts';
import type { InfoGestore } from '../schemas/infoGestore.ts';
import type { InfoProcura } from '../schemas/infoProcura.ts';
import type { MappaGeografica } from '../schemas/mappaGeografica.ts';
import type { ModuloDTO } from '../schemas/moduloDTO.ts';
import type { OnereWithDettaglioDTO } from '../schemas/onereWithDettaglioDTO.ts';
import type { PagamentoWithDettaglioDTO } from '../schemas/pagamentoWithDettaglioDTO.ts';
import type { PostFrontRichiesteIdAzioniInviaParams } from '../schemas/postFrontRichiesteIdAzioniInviaParams.ts';
import type { PostFrontRichiesteIdDelegaBody } from '../schemas/postFrontRichiesteIdDelegaBody.ts';
import type { PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody } from '../schemas/postFrontRichiesteIdModuliIdSezioniIdFileCodiceBody.ts';
import type { PostFrontRichiesteIdModuliIdSezioniIdFileCodiceParams } from '../schemas/postFrontRichiesteIdModuliIdSezioniIdFileCodiceParams.ts';
import type { PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne } from '../schemas/postFrontRichiesteIdModuloIdDocumentoFirmaBodyOne.ts';
import type { PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo } from '../schemas/postFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo.ts';
import type { RichiestaCompetenzaSecondariaDTO } from '../schemas/richiestaCompetenzaSecondariaDTO.ts';
import type { RichiestaDTO } from '../schemas/richiestaDTO.ts';
import type { RichiestaIdratataDTO } from '../schemas/richiestaIdratataDTO.ts';
import type { RichiestaModuloDTO } from '../schemas/richiestaModuloDTO.ts';
import type { RichiesteCsvSearchRequest } from '../schemas/richiesteCsvSearchRequest.ts';
import type { SchedulationResult } from '../schemas/schedulationResult.ts';
import type { SubentroDTO } from '../schemas/subentroDTO.ts';
import type { TipoComunicazioneDestinatarioDTO } from '../schemas/tipoComunicazioneDestinatarioDTO.ts';
import type { UpdateAllegatoRichiestaDTO } from '../schemas/updateAllegatoRichiestaDTO.ts';
import type { UpdateDelegaModulo } from '../schemas/updateDelegaModulo.ts';
import type { UpdateFileFirmatoModuloRichiestaDTO } from '../schemas/updateFileFirmatoModuloRichiestaDTO.ts';
import type { UpdateProcuratoreRequest } from '../schemas/updateProcuratoreRequest.ts';
import type { UpdateRichiestaDTO } from '../schemas/updateRichiestaDTO.ts';
import type { UpdateStatoRichiestaRequest } from '../schemas/updateStatoRichiestaRequest.ts';
import type { UpdateUtenteRequest } from '../schemas/updateUtenteRequest.ts';
import type { Utente } from '../schemas/utente.ts';
import type { ValidazioneResponse } from '../schemas/validazioneResponse.ts';
import type { WsProblema } from '../schemas/wsProblema.ts';
import type { WsRispostaPaginataListRichiestaDTO } from '../schemas/wsRispostaPaginataListRichiestaDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Dettaglio della richiesta, visibile solo da un utente che è compilatore e/o delagato della richiesta
 * @summary Dettaglio richiesta
 */
export const getFrontRichiesteId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaDTO>(
    { url: `/framework-cmp-domande/richieste/${id}`, method: 'get', signal },
    options,
  );
};

export const getGetFrontRichiesteIdQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}`] as const;

export const getGetFrontRichiesteIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFrontRichiesteIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteId>>
  > = ({ signal }) => getFrontRichiesteId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteId>>
>;
export type GetFrontRichiesteIdQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio richiesta
 */
export const useGetFrontRichiesteId = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Modifica richiesta tramite id richiesta
 * @summary Modifica richiesta
 */
export const putFrontRichiesteId = (
  id: string,
  updateRichiestaDTO: UpdateRichiestaDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateRichiestaDTO,
    },
    options,
  );
};

export const getPutFrontRichiesteIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFrontRichiesteId>>,
    TError,
    { id: string; data: UpdateRichiestaDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFrontRichiesteId>>,
  TError,
  { id: string; data: UpdateRichiestaDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFrontRichiesteId>>,
    { id: string; data: UpdateRichiestaDTO }
  > = props => {
    const { id, data } = props ?? {};

    return putFrontRichiesteId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFrontRichiesteIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFrontRichiesteId>>
>;
export type PutFrontRichiesteIdMutationBody = UpdateRichiestaDTO;
export type PutFrontRichiesteIdMutationError = ErrorType<unknown>;

/**
 * @summary Modifica richiesta
 */
export const usePutFrontRichiesteId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFrontRichiesteId>>,
    TError,
    { id: string; data: UpdateRichiestaDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutFrontRichiesteIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancella la richiesta se è in stato BOZZA e/o CREATA
 * @summary Cancellazione richiesta
 */
export const deleteFrontRichiesteId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    { url: `/framework-cmp-domande/richieste/${id}`, method: 'delete' },
    options,
  );
};

export const getDeleteFrontRichiesteIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFrontRichiesteId>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFrontRichiesteId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteFrontRichiesteId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFrontRichiesteIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFrontRichiesteId>>
>;

export type DeleteFrontRichiesteIdMutationError = ErrorType<unknown>;

/**
 * @summary Cancellazione richiesta
 */
export const useDeleteFrontRichiesteId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteFrontRichiesteIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Modifica lo stato di una richiesta da BOZZA a PAGAMENTO o da PAGAMENTO a BOZZA
 * @summary Modifica lo stato di una richiesta da BOZZA a PAGAMENTO o da PAGAMENTO a BOZZA
 */
export const putFrontRichiesteIdStato = (
  id: string,
  updateStatoRichiestaRequest: UpdateStatoRichiestaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/stato`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateStatoRichiestaRequest,
    },
    options,
  );
};

export const getPutFrontRichiesteIdStatoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFrontRichiesteIdStato>>,
    TError,
    { id: string; data: UpdateStatoRichiestaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFrontRichiesteIdStato>>,
  TError,
  { id: string; data: UpdateStatoRichiestaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFrontRichiesteIdStato>>,
    { id: string; data: UpdateStatoRichiestaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putFrontRichiesteIdStato(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFrontRichiesteIdStatoMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFrontRichiesteIdStato>>
>;
export type PutFrontRichiesteIdStatoMutationBody = UpdateStatoRichiestaRequest;
export type PutFrontRichiesteIdStatoMutationError = ErrorType<unknown>;

/**
 * @summary Modifica lo stato di una richiesta da BOZZA a PAGAMENTO o da PAGAMENTO a BOZZA
 */
export const usePutFrontRichiesteIdStato = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFrontRichiesteIdStato>>,
    TError,
    { id: string; data: UpdateStatoRichiestaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutFrontRichiesteIdStatoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggiorna file firmato protocollato sul modulo della richiesta
 * @summary Aggiorna file firmato protocollato sul modulo della richiesta
 */
export const putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato = (
  id: string,
  idRichiestaModulo: string,
  updateFileFirmatoModuloRichiestaDTO: UpdateFileFirmatoModuloRichiestaDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaModuloDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}/aggiornaFileFirmatoProtocollato`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateFileFirmatoModuloRichiestaDTO,
    },
    options,
  );
};

export const getPutFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollatoMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato
        >
      >,
      TError,
      {
        id: string;
        idRichiestaModulo: string;
        data: UpdateFileFirmatoModuloRichiestaDTO;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato
      >
    >,
    TError,
    {
      id: string;
      idRichiestaModulo: string;
      data: UpdateFileFirmatoModuloRichiestaDTO;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato
        >
      >,
      {
        id: string;
        idRichiestaModulo: string;
        data: UpdateFileFirmatoModuloRichiestaDTO;
      }
    > = props => {
      const { id, idRichiestaModulo, data } = props ?? {};

      return putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato(
        id,
        idRichiestaModulo,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollatoMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato
      >
    >
  >;
export type PutFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollatoMutationBody =
  UpdateFileFirmatoModuloRichiestaDTO;
export type PutFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollatoMutationError =
  ErrorType<unknown>;

/**
 * @summary Aggiorna file firmato protocollato sul modulo della richiesta
 */
export const usePutFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollato
      >
    >,
    TError,
    {
      id: string;
      idRichiestaModulo: string;
      data: UpdateFileFirmatoModuloRichiestaDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutFrontRichiesteIdModuliIdAggiornaFileFirmatoProtocollatoMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * Azzera il flag di modifica in integrazione sui moduli della richiesta
 * @summary Azzera il flag di modifica in integrazione sui moduli della richiesta
 */
export const putFrontRichiesteIdAzzeraModificatoInIntegrazione = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/azzeraModificatoInIntegrazione`,
      method: 'put',
    },
    options,
  );
};

export const getPutFrontRichiesteIdAzzeraModificatoInIntegrazioneMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putFrontRichiesteIdAzzeraModificatoInIntegrazione>
      >,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof putFrontRichiesteIdAzzeraModificatoInIntegrazione>
    >,
    TError,
    { id: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putFrontRichiesteIdAzzeraModificatoInIntegrazione>
      >,
      { id: string }
    > = props => {
      const { id } = props ?? {};

      return putFrontRichiesteIdAzzeraModificatoInIntegrazione(
        id,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutFrontRichiesteIdAzzeraModificatoInIntegrazioneMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof putFrontRichiesteIdAzzeraModificatoInIntegrazione>
    >
  >;

export type PutFrontRichiesteIdAzzeraModificatoInIntegrazioneMutationError =
  ErrorType<unknown>;

/**
 * @summary Azzera il flag di modifica in integrazione sui moduli della richiesta
 */
export const usePutFrontRichiesteIdAzzeraModificatoInIntegrazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof putFrontRichiesteIdAzzeraModificatoInIntegrazione>
    >,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutFrontRichiesteIdAzzeraModificatoInIntegrazioneMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * Aggiorna file firmato protocollato sul modulo della richiesta
 * @summary Aggiorna file firmato protocollato sul modulo della richiesta
 */
export const putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato = (
  id: string,
  idAllegato: string,
  updateAllegatoRichiestaDTO: UpdateAllegatoRichiestaDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<AllegatoRichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/allegati/${idAllegato}/aggiornaAllegatoProtocollato`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateAllegatoRichiestaDTO,
    },
    options,
  );
};

export const getPutFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollatoMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato
        >
      >,
      TError,
      { id: string; idAllegato: string; data: UpdateAllegatoRichiestaDTO },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato
      >
    >,
    TError,
    { id: string; idAllegato: string; data: UpdateAllegatoRichiestaDTO },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato
        >
      >,
      { id: string; idAllegato: string; data: UpdateAllegatoRichiestaDTO }
    > = props => {
      const { id, idAllegato, data } = props ?? {};

      return putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato(
        id,
        idAllegato,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollatoMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato
      >
    >
  >;
export type PutFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollatoMutationBody =
  UpdateAllegatoRichiestaDTO;
export type PutFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollatoMutationError =
  ErrorType<unknown>;

/**
 * @summary Aggiorna file firmato protocollato sul modulo della richiesta
 */
export const usePutFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollato
      >
    >,
    TError,
    { id: string; idAllegato: string; data: UpdateAllegatoRichiestaDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutFrontRichiesteIdAllegatiIdAggiornaAllegatoProtocollatoMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * Aggiorna i dati del modulo e delle sue sezioni
 * @summary Aggiorna i dati del modulo e delle sue sezioni
 */
export const putFrontRichiesteIdModuliId = (
  idRichiesta: string,
  idRichiestaModulo: string,
  aggiornaModuloRequest: AggiornaModuloRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<AggiornaModuloResponse>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/moduli/${idRichiestaModulo}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: aggiornaModuloRequest,
    },
    options,
  );
};

export const getPutFrontRichiesteIdModuliIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFrontRichiesteIdModuliId>>,
    TError,
    {
      idRichiesta: string;
      idRichiestaModulo: string;
      data: AggiornaModuloRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFrontRichiesteIdModuliId>>,
  TError,
  {
    idRichiesta: string;
    idRichiestaModulo: string;
    data: AggiornaModuloRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFrontRichiesteIdModuliId>>,
    {
      idRichiesta: string;
      idRichiestaModulo: string;
      data: AggiornaModuloRequest;
    }
  > = props => {
    const { idRichiesta, idRichiestaModulo, data } = props ?? {};

    return putFrontRichiesteIdModuliId(
      idRichiesta,
      idRichiestaModulo,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFrontRichiesteIdModuliIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFrontRichiesteIdModuliId>>
>;
export type PutFrontRichiesteIdModuliIdMutationBody = AggiornaModuloRequest;
export type PutFrontRichiesteIdModuliIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Aggiorna i dati del modulo e delle sue sezioni
 */
export const usePutFrontRichiesteIdModuliId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFrontRichiesteIdModuliId>>,
    TError,
    {
      idRichiesta: string;
      idRichiestaModulo: string;
      data: AggiornaModuloRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutFrontRichiesteIdModuliIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Valida una richiesta
 * @summary Valida una richiesta
 */
export const postFrontRichiesteIdValida = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<EsitoValidazioneRichiestaDTO>(
    { url: `/framework-cmp-domande/richieste/${id}/valida`, method: 'post' },
    options,
  );
};

export const getPostFrontRichiesteIdValidaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdValida>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdValida>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdValida>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postFrontRichiesteIdValida(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdValidaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdValida>>
>;

export type PostFrontRichiesteIdValidaMutationError = ErrorType<WsProblema>;

/**
 * @summary Valida una richiesta
 */
export const usePostFrontRichiesteIdValida = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdValida>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRichiesteIdValidaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Informazioni sul procuratore della richiesta
 * @summary Informazioni sul procuratore
 */
export const getFrontRichiesteIdProcuratore = (
  id: string,
  params?: GetFrontRichiesteIdProcuratoreParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<InfoProcura>(
    {
      url: `/framework-cmp-domande/richieste/${id}/procuratore`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdProcuratoreQueryKey = (
  id: string,
  params?: GetFrontRichiesteIdProcuratoreParams,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/procuratore`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdProcuratoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdProcuratoreParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdProcuratoreQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>
  > = ({ signal }) =>
    getFrontRichiesteIdProcuratore(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdProcuratoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>
>;
export type GetFrontRichiesteIdProcuratoreQueryError = ErrorType<unknown>;

/**
 * @summary Informazioni sul procuratore
 */
export const useGetFrontRichiesteIdProcuratore = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdProcuratoreParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdProcuratore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdProcuratoreQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna il procuratore della richiesta
 * @summary Aggiorna il procuratore
 */
export const postFrontRichiesteIdProcuratore = (
  id: string,
  updateProcuratoreRequest: UpdateProcuratoreRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('codiceFiscale', updateProcuratoreRequest.codiceFiscale);
  if (
    updateProcuratoreRequest.nome !== undefined &&
    updateProcuratoreRequest.nome !== null
  ) {
    formData.append('nome', updateProcuratoreRequest.nome);
  }
  if (
    updateProcuratoreRequest.cognome !== undefined &&
    updateProcuratoreRequest.cognome !== null
  ) {
    formData.append('cognome', updateProcuratoreRequest.cognome);
  }
  if (
    updateProcuratoreRequest.email !== undefined &&
    updateProcuratoreRequest.email !== null
  ) {
    formData.append('email', updateProcuratoreRequest.email);
  }
  if (
    updateProcuratoreRequest.permetteInoltro !== undefined &&
    updateProcuratoreRequest.permetteInoltro !== null
  ) {
    formData.append(
      'permetteInoltro',
      updateProcuratoreRequest.permetteInoltro.toString(),
    );
  }
  if (
    updateProcuratoreRequest.tipoProcura !== undefined &&
    updateProcuratoreRequest.tipoProcura !== null
  ) {
    formData.append('tipoProcura', updateProcuratoreRequest.tipoProcura);
  }
  if (
    updateProcuratoreRequest.assegnaComeGestore !== undefined &&
    updateProcuratoreRequest.assegnaComeGestore !== null
  ) {
    formData.append(
      'assegnaComeGestore',
      updateProcuratoreRequest.assegnaComeGestore.toString(),
    );
  }
  if (
    updateProcuratoreRequest.file !== undefined &&
    updateProcuratoreRequest.file !== null
  ) {
    formData.append('file', updateProcuratoreRequest.file);
  }
  if (
    updateProcuratoreRequest.fileId !== undefined &&
    updateProcuratoreRequest.fileId !== null
  ) {
    formData.append('fileId', updateProcuratoreRequest.fileId);
  }

  return apiClientRequest<InfoProcura>(
    {
      url: `/framework-cmp-domande/richieste/${id}/procuratore`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostFrontRichiesteIdProcuratoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdProcuratore>>,
    TError,
    { id: string; data: UpdateProcuratoreRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdProcuratore>>,
  TError,
  { id: string; data: UpdateProcuratoreRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdProcuratore>>,
    { id: string; data: UpdateProcuratoreRequest }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdProcuratore(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdProcuratoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdProcuratore>>
>;
export type PostFrontRichiesteIdProcuratoreMutationBody =
  UpdateProcuratoreRequest;
export type PostFrontRichiesteIdProcuratoreMutationError = ErrorType<unknown>;

/**
 * @summary Aggiorna il procuratore
 */
export const usePostFrontRichiesteIdProcuratore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdProcuratore>>,
    TError,
    { id: string; data: UpdateProcuratoreRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdProcuratoreMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rimuove il procuratore della richiesta
 * @summary Rimuove il procuratore
 */
export const deleteFrontRichiesteIdProcuratore = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/procuratore`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteFrontRichiesteIdProcuratoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteIdProcuratore>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFrontRichiesteIdProcuratore>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFrontRichiesteIdProcuratore>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteFrontRichiesteIdProcuratore(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFrontRichiesteIdProcuratoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFrontRichiesteIdProcuratore>>
>;

export type DeleteFrontRichiesteIdProcuratoreMutationError = ErrorType<unknown>;

/**
 * @summary Rimuove il procuratore
 */
export const useDeleteFrontRichiesteIdProcuratore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteIdProcuratore>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteFrontRichiesteIdProcuratoreMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Restituisce l’elenco di tutti i pagamenti associati a una domanda
 * @summary Recupero elenco pagamenti associati ad una domanda
 */
export const getFrontRichiesteIdPagamenti = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PagamentoWithDettaglioDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdPagamentiQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/pagamenti`] as const;

export const getGetFrontRichiesteIdPagamentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdPagamentiQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>
  > = ({ signal }) => getFrontRichiesteIdPagamenti(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdPagamentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>
>;
export type GetFrontRichiesteIdPagamentiQueryError = ErrorType<unknown>;

/**
 * @summary Recupero elenco pagamenti associati ad una domanda
 */
export const useGetFrontRichiesteIdPagamenti = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdPagamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdPagamentiQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * A partire da un insieme di oneri selezionati manualmente dall'utente, crea in automatico i pagamenti (pacchetti di oneri )per il pagamento
 * @summary Crea un pagamento da effettuare e associa a questo dei pacchetti di oneri
 */
export const postFrontRichiesteIdPagamenti = (
  id: string,
  createPagamentoOneriRequest: CreatePagamentoOneriRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createPagamentoOneriRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteIdPagamentiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamenti>>,
    TError,
    { id: string; data: CreatePagamentoOneriRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdPagamenti>>,
  TError,
  { id: string; data: CreatePagamentoOneriRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamenti>>,
    { id: string; data: CreatePagamentoOneriRequest }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdPagamenti(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdPagamentiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdPagamenti>>
>;
export type PostFrontRichiesteIdPagamentiMutationBody =
  CreatePagamentoOneriRequest;
export type PostFrontRichiesteIdPagamentiMutationError = ErrorType<unknown>;

/**
 * @summary Crea un pagamento da effettuare e associa a questo dei pacchetti di oneri
 */
export const usePostFrontRichiesteIdPagamenti = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamenti>>,
    TError,
    { id: string; data: CreatePagamentoOneriRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdPagamentiMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Avvia una transazione per il pagamento online (Modello 1) spontaneo e restituisce l’URL verso il quale effettuare il redirect lato frontend
 * @summary avvia un pagamento online (Modello 1)
 */
export const postFrontRichiesteIdPagamentiIdPagamentoOnline = (
  id: string,
  idPagamento: string,
  avviaPagamentoOnlineRequest: AvviaPagamentoOnlineRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/pagamento-online`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: avviaPagamentoOnlineRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteIdPagamentiIdPagamentoOnlineMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoOnline>
      >,
      TError,
      { id: string; idPagamento: string; data: AvviaPagamentoOnlineRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoOnline>>,
    TError,
    { id: string; idPagamento: string; data: AvviaPagamentoOnlineRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoOnline>
      >,
      { id: string; idPagamento: string; data: AvviaPagamentoOnlineRequest }
    > = props => {
      const { id, idPagamento, data } = props ?? {};

      return postFrontRichiesteIdPagamentiIdPagamentoOnline(
        id,
        idPagamento,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostFrontRichiesteIdPagamentiIdPagamentoOnlineMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoOnline>>
  >;
export type PostFrontRichiesteIdPagamentiIdPagamentoOnlineMutationBody =
  AvviaPagamentoOnlineRequest;
export type PostFrontRichiesteIdPagamentiIdPagamentoOnlineMutationError =
  ErrorType<unknown>;

/**
 * @summary avvia un pagamento online (Modello 1)
 */
export const usePostFrontRichiesteIdPagamentiIdPagamentoOnline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoOnline>>,
    TError,
    { id: string; idPagamento: string; data: AvviaPagamentoOnlineRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdPagamentiIdPagamentoOnlineMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Avvia un pagamento per il pagamento tramite marca da bollo digitale (Modello e-bollo) e restituisce il RID relativo alla richiesta
 * @summary avvia un pagamento di un e-bollo (Modello e-bollo)
 */
export const postFrontRichiesteIdPagamentiIdPagamentoEbollo = (
  id: string,
  idPagamento: string,
  avviaEBolloRequest: AvviaEBolloRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/pagamento-ebollo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: avviaEBolloRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteIdPagamentiIdPagamentoEbolloMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoEbollo>
      >,
      TError,
      { id: string; idPagamento: string; data: AvviaEBolloRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoEbollo>>,
    TError,
    { id: string; idPagamento: string; data: AvviaEBolloRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoEbollo>
      >,
      { id: string; idPagamento: string; data: AvviaEBolloRequest }
    > = props => {
      const { id, idPagamento, data } = props ?? {};

      return postFrontRichiesteIdPagamentiIdPagamentoEbollo(
        id,
        idPagamento,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostFrontRichiesteIdPagamentiIdPagamentoEbolloMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoEbollo>>
  >;
export type PostFrontRichiesteIdPagamentiIdPagamentoEbolloMutationBody =
  AvviaEBolloRequest;
export type PostFrontRichiesteIdPagamentiIdPagamentoEbolloMutationError =
  ErrorType<unknown>;

/**
 * @summary avvia un pagamento di un e-bollo (Modello e-bollo)
 */
export const usePostFrontRichiesteIdPagamentiIdPagamentoEbollo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdPagamentiIdPagamentoEbollo>>,
    TError,
    { id: string; idPagamento: string; data: AvviaEBolloRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdPagamentiIdPagamentoEbolloMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Annulla una richiesta di pagamento online precedentemente inviata al sistema di pagamento. Operazione supportata solo dal sistema di pagamento PagoPA Basilicata.
 * @summary Annulla la richiesta di pagamento online
 */
export const postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline = (
  id: string,
  idPagamento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/annulla-pagamento-online`,
      method: 'post',
    },
    options,
  );
};

export const getPostFrontRichiesteIdPagamentiIdAnnullaPagamentoOnlineMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline>
      >,
      TError,
      { id: string; idPagamento: string },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline>
    >,
    TError,
    { id: string; idPagamento: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline>
      >,
      { id: string; idPagamento: string }
    > = props => {
      const { id, idPagamento } = props ?? {};

      return postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline(
        id,
        idPagamento,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostFrontRichiesteIdPagamentiIdAnnullaPagamentoOnlineMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline>
    >
  >;

export type PostFrontRichiesteIdPagamentiIdAnnullaPagamentoOnlineMutationError =
  ErrorType<unknown>;

/**
 * @summary Annulla la richiesta di pagamento online
 */
export const usePostFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof postFrontRichiesteIdPagamentiIdAnnullaPagamentoOnline>
    >,
    TError,
    { id: string; idPagamento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdPagamentiIdAnnullaPagamentoOnlineMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * Aggiorna lo stato della richiesta modulo
 * @summary Aggiorna lo stato della richiesta modulo
 */
export const postFrontRichiesteIdModuliIdStato = (
  id: string,
  idRichiestaModulo: string,
  cambiamentoStatoRequest: CambiamentoStatoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}/stato`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: cambiamentoStatoRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteIdModuliIdStatoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdStato>>,
    TError,
    { id: string; idRichiestaModulo: string; data: CambiamentoStatoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdStato>>,
  TError,
  { id: string; idRichiestaModulo: string; data: CambiamentoStatoRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdStato>>,
    { id: string; idRichiestaModulo: string; data: CambiamentoStatoRequest }
  > = props => {
    const { id, idRichiestaModulo, data } = props ?? {};

    return postFrontRichiesteIdModuliIdStato(
      id,
      idRichiestaModulo,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdModuliIdStatoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdStato>>
>;
export type PostFrontRichiesteIdModuliIdStatoMutationBody =
  CambiamentoStatoRequest;
export type PostFrontRichiesteIdModuliIdStatoMutationError = ErrorType<unknown>;

/**
 * @summary Aggiorna lo stato della richiesta modulo
 */
export const usePostFrontRichiesteIdModuliIdStato = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdStato>>,
    TError,
    { id: string; idRichiestaModulo: string; data: CambiamentoStatoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdModuliIdStatoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Scarica un allegato
 */
export const getFrontRichiesteIdModuliIdSezioniIdFileCodice = (
  id: string,
  idRichiestaModulo: string,
  idSezione: string,
  codice: string,
  params?: GetFrontRichiesteIdModuliIdSezioniIdFileCodiceParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}/sezioni/${idSezione}/file/${codice}`,
      method: 'get',
      params,
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryKey = (
  id: string,
  idRichiestaModulo: string,
  idSezione: string,
  codice: string,
  params?: GetFrontRichiesteIdModuliIdSezioniIdFileCodiceParams,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}/sezioni/${idSezione}/file/${codice}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  idRichiestaModulo: string,
  idSezione: string,
  codice: string,
  params?: GetFrontRichiesteIdModuliIdSezioniIdFileCodiceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryKey(
      id,
      idRichiestaModulo,
      idSezione,
      codice,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuliIdSezioniIdFileCodice(
      id,
      idRichiestaModulo,
      idSezione,
      codice,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(id && idRichiestaModulo && idSezione && codice),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>>
  >;
export type GetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryError =
  ErrorType<unknown>;

/**
 * @summary Scarica un allegato
 */
export const useGetFrontRichiesteIdModuliIdSezioniIdFileCodice = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  idRichiestaModulo: string,
  idSezione: string,
  codice: string,
  params?: GetFrontRichiesteIdModuliIdSezioniIdFileCodiceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuliIdSezioniIdFileCodice>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryOptions(
      id,
      idRichiestaModulo,
      idSezione,
      codice,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiunge allegato
 * @summary Aggiunge allegato
 */
export const postFrontRichiesteIdModuliIdSezioniIdFileCodice = (
  id: string,
  idRichiestaModulo: string,
  idSezione: string,
  codice: string,
  postFrontRichiesteIdModuliIdSezioniIdFileCodiceBody: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody,
  params?: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append(
    'file',
    postFrontRichiesteIdModuliIdSezioniIdFileCodiceBody.file,
  );

  return apiClientRequest<AggiungiAllegatoResult>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}/sezioni/${idSezione}/file/${codice}`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    },
    options,
  );
};

export const getPostFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdModuliIdSezioniIdFileCodice>
      >,
      TError,
      {
        id: string;
        idRichiestaModulo: string;
        idSezione: string;
        codice: string;
        data: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody;
        params?: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdSezioniIdFileCodice>>,
    TError,
    {
      id: string;
      idRichiestaModulo: string;
      idSezione: string;
      codice: string;
      data: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody;
      params?: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postFrontRichiesteIdModuliIdSezioniIdFileCodice>
      >,
      {
        id: string;
        idRichiestaModulo: string;
        idSezione: string;
        codice: string;
        data: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody;
        params?: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
      }
    > = props => {
      const { id, idRichiestaModulo, idSezione, codice, data, params } =
        props ?? {};

      return postFrontRichiesteIdModuliIdSezioniIdFileCodice(
        id,
        idRichiestaModulo,
        idSezione,
        codice,
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdSezioniIdFileCodice>>
  >;
export type PostFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationBody =
  PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody;
export type PostFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationError =
  ErrorType<unknown>;

/**
 * @summary Aggiunge allegato
 */
export const usePostFrontRichiesteIdModuliIdSezioniIdFileCodice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliIdSezioniIdFileCodice>>,
    TError,
    {
      id: string;
      idRichiestaModulo: string;
      idSezione: string;
      codice: string;
      data: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceBody;
      params?: PostFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Cancella un allegato
 */
export const deleteFrontRichiesteIdModuliIdSezioniIdFileCodice = (
  id: string,
  idRichiestaModulo: string,
  idSezione: string,
  codice: string,
  params?: DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}/sezioni/${idSezione}/file/${codice}`,
      method: 'delete',
      params,
    },
    options,
  );
};

export const getDeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteFrontRichiesteIdModuliIdSezioniIdFileCodice>
      >,
      TError,
      {
        id: string;
        idRichiestaModulo: string;
        idSezione: string;
        codice: string;
        params?: DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteFrontRichiesteIdModuliIdSezioniIdFileCodice>
    >,
    TError,
    {
      id: string;
      idRichiestaModulo: string;
      idSezione: string;
      codice: string;
      params?: DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteFrontRichiesteIdModuliIdSezioniIdFileCodice>
      >,
      {
        id: string;
        idRichiestaModulo: string;
        idSezione: string;
        codice: string;
        params?: DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
      }
    > = props => {
      const { id, idRichiestaModulo, idSezione, codice, params } = props ?? {};

      return deleteFrontRichiesteIdModuliIdSezioniIdFileCodice(
        id,
        idRichiestaModulo,
        idSezione,
        codice,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteFrontRichiesteIdModuliIdSezioniIdFileCodice>
    >
  >;

export type DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationError =
  ErrorType<unknown>;

/**
 * @summary Cancella un allegato
 */
export const useDeleteFrontRichiesteIdModuliIdSezioniIdFileCodice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteFrontRichiesteIdModuliIdSezioniIdFileCodice>
    >,
    TError,
    {
      id: string;
      idRichiestaModulo: string;
      idSezione: string;
      codice: string;
      params?: DeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteFrontRichiesteIdModuliIdSezioniIdFileCodiceMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * Recupera tutte le deleghe presenti sui moduli
 * @summary Recupera tutte le deleghe presenti sui moduli
 */
export const getFrontRichiesteIdModuliDeleghe = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<DelegaModulo[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/deleghe`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuliDelegheQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/moduli/deleghe`] as const;

export const getGetFrontRichiesteIdModuliDelegheQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdModuliDelegheQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuliDeleghe(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdModuliDelegheQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>
>;
export type GetFrontRichiesteIdModuliDelegheQueryError = ErrorType<unknown>;

/**
 * @summary Recupera tutte le deleghe presenti sui moduli
 */
export const useGetFrontRichiesteIdModuliDeleghe = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuliDeleghe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdModuliDelegheQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna le deleghe di tutte le richieste modulo
 * @summary Aggiorna le deleghe
 */
export const postFrontRichiesteIdModuliDeleghe = (
  id: string,
  updateDelegaModulo: UpdateDelegaModulo[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<DelegaModulo[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/deleghe`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: updateDelegaModulo,
    },
    options,
  );
};

export const getPostFrontRichiesteIdModuliDelegheMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliDeleghe>>,
    TError,
    { id: string; data: UpdateDelegaModulo[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdModuliDeleghe>>,
  TError,
  { id: string; data: UpdateDelegaModulo[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliDeleghe>>,
    { id: string; data: UpdateDelegaModulo[] }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdModuliDeleghe(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdModuliDelegheMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdModuliDeleghe>>
>;
export type PostFrontRichiesteIdModuliDelegheMutationBody =
  UpdateDelegaModulo[];
export type PostFrontRichiesteIdModuliDelegheMutationError = ErrorType<unknown>;

/**
 * @summary Aggiorna le deleghe
 */
export const usePostFrontRichiesteIdModuliDeleghe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuliDeleghe>>,
    TError,
    { id: string; data: UpdateDelegaModulo[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdModuliDelegheMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Inoltra una richiesta
 * @summary Inoltra una richiesta
 */
export const postFrontRichiesteIdInoltra = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    { url: `/framework-cmp-domande/richieste/${id}/inoltra`, method: 'post' },
    options,
  );
};

export const getPostFrontRichiesteIdInoltraMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdInoltra>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdInoltra>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdInoltra>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postFrontRichiesteIdInoltra(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdInoltraMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdInoltra>>
>;

export type PostFrontRichiesteIdInoltraMutationError = ErrorType<WsProblema>;

/**
 * @summary Inoltra una richiesta
 */
export const usePostFrontRichiesteIdInoltra = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdInoltra>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdInoltraMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Informazioni sul gestore della richiesta
 * @summary Informazioni sul gestore
 */
export const getFrontRichiesteIdGestore = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<InfoGestore>(
    {
      url: `/framework-cmp-domande/richieste/${id}/gestore`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdGestoreQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/gestore`] as const;

export const getGetFrontRichiesteIdGestoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdGestoreQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>
  > = ({ signal }) => getFrontRichiesteIdGestore(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdGestoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>
>;
export type GetFrontRichiesteIdGestoreQueryError = ErrorType<unknown>;

/**
 * @summary Informazioni sul gestore
 */
export const useGetFrontRichiesteIdGestore = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdGestore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdGestoreQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna il gestore della richiesta
 * @summary Aggiorna il gestore
 */
export const postFrontRichiesteIdGestore = (
  id: string,
  updateUtenteRequest: UpdateUtenteRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<InfoGestore>(
    {
      url: `/framework-cmp-domande/richieste/${id}/gestore`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: updateUtenteRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteIdGestoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdGestore>>,
    TError,
    { id: string; data: UpdateUtenteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdGestore>>,
  TError,
  { id: string; data: UpdateUtenteRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdGestore>>,
    { id: string; data: UpdateUtenteRequest }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdGestore(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdGestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdGestore>>
>;
export type PostFrontRichiesteIdGestoreMutationBody = UpdateUtenteRequest;
export type PostFrontRichiesteIdGestoreMutationError = ErrorType<unknown>;

/**
 * @summary Aggiorna il gestore
 */
export const usePostFrontRichiesteIdGestore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdGestore>>,
    TError,
    { id: string; data: UpdateUtenteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdGestoreMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postFrontRichiesteIdDelega = (
  id: string,
  postFrontRichiesteIdDelegaBody: PostFrontRichiesteIdDelegaBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  if (postFrontRichiesteIdDelegaBody.file !== undefined) {
    formData.append('file', postFrontRichiesteIdDelegaBody.file);
  }
  formData.append('datiDelega', postFrontRichiesteIdDelegaBody.datiDelega);

  return apiClientRequest<void>(
    {
      url: `/framework-cmp-domande/richieste/${id}/delega`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostFrontRichiesteIdDelegaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdDelega>>,
    TError,
    { id: string; data: PostFrontRichiesteIdDelegaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdDelega>>,
  TError,
  { id: string; data: PostFrontRichiesteIdDelegaBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdDelega>>,
    { id: string; data: PostFrontRichiesteIdDelegaBody }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdDelega(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdDelegaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdDelega>>
>;
export type PostFrontRichiesteIdDelegaMutationBody =
  PostFrontRichiesteIdDelegaBody;
export type PostFrontRichiesteIdDelegaMutationError = ErrorType<unknown>;

export const usePostFrontRichiesteIdDelega = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdDelega>>,
    TError,
    { id: string; data: PostFrontRichiesteIdDelegaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRichiesteIdDelegaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Carica una delega
 */
export const deleteFrontRichiesteIdDelega = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cmp-domande/richieste/${id}/delega`, method: 'delete' },
    options,
  );
};

export const getDeleteFrontRichiesteIdDelegaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteIdDelega>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFrontRichiesteIdDelega>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFrontRichiesteIdDelega>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteFrontRichiesteIdDelega(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFrontRichiesteIdDelegaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFrontRichiesteIdDelega>>
>;

export type DeleteFrontRichiesteIdDelegaMutationError = ErrorType<unknown>;

/**
 * @summary Carica una delega
 */
export const useDeleteFrontRichiesteIdDelega = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteIdDelega>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteFrontRichiesteIdDelegaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Duplica la richiesta
 * @summary Duplicazione della richiesta
 */
export const postFrontRichiesteIdCopia = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    { url: `/framework-cmp-domande/richieste/${id}/copia`, method: 'post' },
    options,
  );
};

export const getPostFrontRichiesteIdCopiaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdCopia>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdCopia>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdCopia>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postFrontRichiesteIdCopia(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdCopiaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdCopia>>
>;

export type PostFrontRichiesteIdCopiaMutationError = ErrorType<WsProblema>;

/**
 * @summary Duplicazione della richiesta
 */
export const usePostFrontRichiesteIdCopia = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdCopia>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRichiesteIdCopiaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Restituisce la lista degli id delle competenze associate a una richiesta
 * @summary Chiamata b2b dal be
 */
export const postFrontRichiesteIdCompetenzeRichiesta = (
  id: string,
  utente: Utente,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/competenze-richiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: utente,
    },
    options,
  );
};

export const getPostFrontRichiesteIdCompetenzeRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdCompetenzeRichiesta>>,
    TError,
    { id: string; data: Utente },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdCompetenzeRichiesta>>,
  TError,
  { id: string; data: Utente },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdCompetenzeRichiesta>>,
    { id: string; data: Utente }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdCompetenzeRichiesta(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdCompetenzeRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdCompetenzeRichiesta>>
>;
export type PostFrontRichiesteIdCompetenzeRichiestaMutationBody = Utente;
export type PostFrontRichiesteIdCompetenzeRichiestaMutationError =
  ErrorType<unknown>;

/**
 * @summary Chiamata b2b dal be
 */
export const usePostFrontRichiesteIdCompetenzeRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdCompetenzeRichiesta>>,
    TError,
    { id: string; data: Utente },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdCompetenzeRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Invio di una richiesta
 * @summary Invio di una richiesta
 */
export const postFrontRichiesteIdAzioniInvia = (
  id: string,
  params?: PostFrontRichiesteIdAzioniInviaParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/azioni/invia`,
      method: 'post',
      params,
    },
    options,
  );
};

export const getPostFrontRichiesteIdAzioniInviaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniInvia>>,
    TError,
    { id: string; params?: PostFrontRichiesteIdAzioniInviaParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdAzioniInvia>>,
  TError,
  { id: string; params?: PostFrontRichiesteIdAzioniInviaParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniInvia>>,
    { id: string; params?: PostFrontRichiesteIdAzioniInviaParams }
  > = props => {
    const { id, params } = props ?? {};

    return postFrontRichiesteIdAzioniInvia(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdAzioniInviaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdAzioniInvia>>
>;

export type PostFrontRichiesteIdAzioniInviaMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Invio di una richiesta
 */
export const usePostFrontRichiesteIdAzioniInvia = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniInvia>>,
    TError,
    { id: string; params?: PostFrontRichiesteIdAzioniInviaParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdAzioniInviaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Processo che integra una richiesta
 * @summary Integrazione di una richiesta
 */
export const postFrontRichiesteIdAzioniIntegra = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/azioni/integra`,
      method: 'post',
    },
    options,
  );
};

export const getPostFrontRichiesteIdAzioniIntegraMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniIntegra>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdAzioniIntegra>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniIntegra>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postFrontRichiesteIdAzioniIntegra(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdAzioniIntegraMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdAzioniIntegra>>
>;

export type PostFrontRichiesteIdAzioniIntegraMutationError = ErrorType<unknown>;

/**
 * @summary Integrazione di una richiesta
 */
export const usePostFrontRichiesteIdAzioniIntegra = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniIntegra>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdAzioniIntegraMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Annulla una richiesta
 * @summary Annulla una richiesta
 */
export const postFrontRichiesteIdAzioniAnnulla = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/azioni/annulla`,
      method: 'post',
    },
    options,
  );
};

export const getPostFrontRichiesteIdAzioniAnnullaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniAnnulla>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdAzioniAnnulla>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniAnnulla>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postFrontRichiesteIdAzioniAnnulla(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdAzioniAnnullaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdAzioniAnnulla>>
>;

export type PostFrontRichiesteIdAzioniAnnullaMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Annulla una richiesta
 */
export const usePostFrontRichiesteIdAzioniAnnulla = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAzioniAnnulla>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdAzioniAnnullaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Annulla la delega ricevuta dall'utente in sessione sulla richiesta o su uno dei suoi moduli. Se il corpo indica un modulo l'annullamento riguarda la delega su quel modulo, altrimenti l'intera richiesta. L'attore non e' mai passato dal client: e' desunto dai dati di sessione.
 * @summary Annulla la delega ricevuta dall'utente in sessione
 */
export const postFrontRichiesteIdAnnullaDelega = (
  id: string,
  annullaDelegaRequest: AnnullaDelegaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<AnnullaDelegaResponse>(
    {
      url: `/framework-cmp-domande/richieste/${id}/annulla-delega`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: annullaDelegaRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteIdAnnullaDelegaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAnnullaDelega>>,
    TError,
    { id: string; data: AnnullaDelegaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdAnnullaDelega>>,
  TError,
  { id: string; data: AnnullaDelegaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdAnnullaDelega>>,
    { id: string; data: AnnullaDelegaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiesteIdAnnullaDelega(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdAnnullaDelegaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteIdAnnullaDelega>>
>;
export type PostFrontRichiesteIdAnnullaDelegaMutationBody =
  AnnullaDelegaRequest;
export type PostFrontRichiesteIdAnnullaDelegaMutationError = ErrorType<unknown>;

/**
 * @summary Annulla la delega ricevuta dall'utente in sessione
 */
export const usePostFrontRichiesteIdAnnullaDelega = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdAnnullaDelega>>,
    TError,
    { id: string; data: AnnullaDelegaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdAnnullaDelegaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Caricamento documento firmato
 * @summary Caricamento documento firmato
 */
export const postFrontRichiesteIdModuloIdDocumentoFirma = (
  idRichiesta: string,
  idRichiestaModulo: string,
  postFrontRichiesteIdModuloIdDocumentoFirmaBody:
    | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne
    | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaModuloDTO>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-firma`,
      method: 'post',
      data: postFrontRichiesteIdModuloIdDocumentoFirmaBody,
    },
    options,
  );
};

export const getPostFrontRichiesteIdModuloIdDocumentoFirmaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuloIdDocumentoFirma>>,
    TError,
    {
      idRichiesta: string;
      idRichiestaModulo: string;
      data:
        | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne
        | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteIdModuloIdDocumentoFirma>>,
  TError,
  {
    idRichiesta: string;
    idRichiestaModulo: string;
    data:
      | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne
      | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuloIdDocumentoFirma>>,
    {
      idRichiesta: string;
      idRichiestaModulo: string;
      data:
        | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne
        | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo;
    }
  > = props => {
    const { idRichiesta, idRichiestaModulo, data } = props ?? {};

    return postFrontRichiesteIdModuloIdDocumentoFirma(
      idRichiesta,
      idRichiestaModulo,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteIdModuloIdDocumentoFirmaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuloIdDocumentoFirma>>
  >;
export type PostFrontRichiesteIdModuloIdDocumentoFirmaMutationBody =
  | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne
  | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo;
export type PostFrontRichiesteIdModuloIdDocumentoFirmaMutationError =
  ErrorType<unknown>;

/**
 * @summary Caricamento documento firmato
 */
export const usePostFrontRichiesteIdModuloIdDocumentoFirma = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteIdModuloIdDocumentoFirma>>,
    TError,
    {
      idRichiesta: string;
      idRichiestaModulo: string;
      data:
        | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyOne
        | PostFrontRichiesteIdModuloIdDocumentoFirmaBodyTwo;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteIdModuloIdDocumentoFirmaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postFrontRichiesteXlsx = (
  richiesteCsvSearchRequest: RichiesteCsvSearchRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cmp-domande/richieste/xlsx`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: richiesteCsvSearchRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteXlsx>>,
    TError,
    { data: RichiesteCsvSearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteXlsx>>,
  TError,
  { data: RichiesteCsvSearchRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteXlsx>>,
    { data: RichiesteCsvSearchRequest }
  > = props => {
    const { data } = props ?? {};

    return postFrontRichiesteXlsx(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteXlsx>>
>;
export type PostFrontRichiesteXlsxMutationBody = RichiesteCsvSearchRequest;
export type PostFrontRichiesteXlsxMutationError = ErrorType<unknown>;

export const usePostFrontRichiesteXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteXlsx>>,
    TError,
    { data: RichiesteCsvSearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRichiesteXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Chiamata batch che uno scheduler può effettuare per verificare lo stato di pagamenti modello3
 * @summary Chiamata batch che uno scheduler può effettuare per verificare lo stato di pagamenti modello3
 */
export const postFrontRichiesteVerificaPagamentiModello3 = (
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SchedulationResult>(
    {
      url: `/framework-cmp-domande/richieste/verifica-pagamenti-modello3`,
      method: 'post',
    },
    options,
  );
};

export const getPostFrontRichiesteVerificaPagamentiModello3MutationOptions = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteVerificaPagamentiModello3>>,
    TError,
    TVariables,
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteVerificaPagamentiModello3>>,
  TError,
  TVariables,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteVerificaPagamentiModello3>>,
    TVariables
  > = () => {
    return postFrontRichiesteVerificaPagamentiModello3(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteVerificaPagamentiModello3MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postFrontRichiesteVerificaPagamentiModello3>>
  >;

export type PostFrontRichiesteVerificaPagamentiModello3MutationError =
  ErrorType<unknown>;

/**
 * @summary Chiamata batch che uno scheduler può effettuare per verificare lo stato di pagamenti modello3
 */
export const usePostFrontRichiesteVerificaPagamentiModello3 = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteVerificaPagamentiModello3>>,
    TError,
    TVariables,
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteVerificaPagamentiModello3MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Avvia sincronizzazione subentro su una richiesta di un procedimento pratica
 * @summary Avvia sincronizzazione subentro richiesta di una pratica
 */
export const postFrontRichiestePraticaIdSubentro = (
  id: string,
  subentroDTO: SubentroDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cmp-domande/richieste/pratica/${id}/subentro`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: subentroDTO,
    },
    options,
  );
};

export const getPostFrontRichiestePraticaIdSubentroMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiestePraticaIdSubentro>>,
    TError,
    { id: string; data: SubentroDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiestePraticaIdSubentro>>,
  TError,
  { id: string; data: SubentroDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiestePraticaIdSubentro>>,
    { id: string; data: SubentroDTO }
  > = props => {
    const { id, data } = props ?? {};

    return postFrontRichiestePraticaIdSubentro(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiestePraticaIdSubentroMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiestePraticaIdSubentro>>
>;
export type PostFrontRichiestePraticaIdSubentroMutationBody = SubentroDTO;
export type PostFrontRichiestePraticaIdSubentroMutationError =
  ErrorType<unknown>;

/**
 * @summary Avvia sincronizzazione subentro richiesta di una pratica
 */
export const usePostFrontRichiestePraticaIdSubentro = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiestePraticaIdSubentro>>,
    TError,
    { id: string; data: SubentroDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiestePraticaIdSubentroMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postFrontRichiesteGeojson = (
  richiesteCsvSearchRequest: RichiesteCsvSearchRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cmp-domande/richieste/geojson`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: richiesteCsvSearchRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteGeojsonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteGeojson>>,
    TError,
    { data: RichiesteCsvSearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteGeojson>>,
  TError,
  { data: RichiesteCsvSearchRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteGeojson>>,
    { data: RichiesteCsvSearchRequest }
  > = props => {
    const { data } = props ?? {};

    return postFrontRichiesteGeojson(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteGeojsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteGeojson>>
>;
export type PostFrontRichiesteGeojsonMutationBody = RichiesteCsvSearchRequest;
export type PostFrontRichiesteGeojsonMutationError = ErrorType<unknown>;

export const usePostFrontRichiesteGeojson = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteGeojson>>,
    TError,
    { data: RichiesteCsvSearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRichiesteGeojsonMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postFrontRichiesteCsv = (
  richiesteCsvSearchRequest: RichiesteCsvSearchRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-cmp-domande/richieste/csv`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: richiesteCsvSearchRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteCsvMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteCsv>>,
    TError,
    { data: RichiesteCsvSearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteCsv>>,
  TError,
  { data: RichiesteCsvSearchRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteCsv>>,
    { data: RichiesteCsvSearchRequest }
  > = props => {
    const { data } = props ?? {};

    return postFrontRichiesteCsv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteCsv>>
>;
export type PostFrontRichiesteCsvMutationBody = RichiesteCsvSearchRequest;
export type PostFrontRichiesteCsvMutationError = ErrorType<unknown>;

export const usePostFrontRichiesteCsv = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteCsv>>,
    TError,
    { data: RichiesteCsvSearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRichiesteCsvMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggiunge l'id istanza procedimento di una pratica, alla richiesta
 * @summary Modifica richiesta
 */
export const patchFrontRichiesteIdLinkPraticaId = (
  id: string,
  idIstanzaProcedimentoPratica: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/link-pratica/${idIstanzaProcedimentoPratica}`,
      method: 'patch',
    },
    options,
  );
};

export const getPatchFrontRichiesteIdLinkPraticaIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchFrontRichiesteIdLinkPraticaId>>,
    TError,
    { id: string; idIstanzaProcedimentoPratica: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchFrontRichiesteIdLinkPraticaId>>,
  TError,
  { id: string; idIstanzaProcedimentoPratica: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchFrontRichiesteIdLinkPraticaId>>,
    { id: string; idIstanzaProcedimentoPratica: string }
  > = props => {
    const { id, idIstanzaProcedimentoPratica } = props ?? {};

    return patchFrontRichiesteIdLinkPraticaId(
      id,
      idIstanzaProcedimentoPratica,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchFrontRichiesteIdLinkPraticaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchFrontRichiesteIdLinkPraticaId>>
>;

export type PatchFrontRichiesteIdLinkPraticaIdMutationError =
  ErrorType<unknown>;

/**
 * @summary Modifica richiesta
 */
export const usePatchFrontRichiesteIdLinkPraticaId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchFrontRichiesteIdLinkPraticaId>>,
    TError,
    { id: string; idIstanzaProcedimentoPratica: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPatchFrontRichiesteIdLinkPraticaIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene l'elenco delle richieste effettuate dall'utente
 * @summary Elenco richieste
 */
export const getFrontRichieste = (
  params?: GetFrontRichiesteParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListRichiestaDTO>(
    { url: `/framework-cmp-domande/richieste`, method: 'get', params, signal },
    options,
  );
};

export const getGetFrontRichiesteQueryKey = (
  params?: GetFrontRichiesteParams,
) => [`/framework-cmp-domande/richieste`, ...(params ? [params] : [])] as const;

export const getGetFrontRichiesteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichieste>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFrontRichiesteParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichieste>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichieste>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichieste>>
  > = ({ signal }) => getFrontRichieste(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontRichiesteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichieste>>
>;
export type GetFrontRichiesteQueryError = ErrorType<unknown>;

/**
 * @summary Elenco richieste
 */
export const useGetFrontRichieste = <
  TData = Awaited<ReturnType<typeof getFrontRichieste>>,
  TError = ErrorType<unknown>,
>(
  params?: GetFrontRichiesteParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichieste>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dettaglio della richiesta, visibile solo da un utente che è compilatore e/o delagato della richiestas
 * @summary Dettaglio richiesta
 */
export const getFrontRichiesteIdValidatore = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ValidazioneResponse[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/validatore`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdValidatoreQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/validatore`] as const;

export const getGetFrontRichiesteIdValidatoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdValidatoreQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>
  > = ({ signal }) => getFrontRichiesteIdValidatore(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdValidatoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>
>;
export type GetFrontRichiesteIdValidatoreQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio richiesta
 */
export const useGetFrontRichiesteIdValidatore = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdValidatore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdValidatoreQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette di scaricare il documento PDF di riepilogo della richiesta da sottoporre alla firma.
 * @summary API di Download del Riepilogo da firmare.
 */
export const getFrontRichiesteIdRiepilogoDaFirmareDownload = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${id}/riepilogo/da-firmare/download`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdRiepilogoDaFirmareDownloadQueryKey = (
  id: string,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/riepilogo/da-firmare/download`,
  ] as const;

export const getGetFrontRichiesteIdRiepilogoDaFirmareDownloadQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>
  >,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdRiepilogoDaFirmareDownloadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>>
  > = ({ signal }) =>
    getFrontRichiesteIdRiepilogoDaFirmareDownload(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdRiepilogoDaFirmareDownloadQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>>
  >;
export type GetFrontRichiesteIdRiepilogoDaFirmareDownloadQueryError =
  ErrorType<void>;

/**
 * @summary API di Download del Riepilogo da firmare.
 */
export const useGetFrontRichiesteIdRiepilogoDaFirmareDownload = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>
  >,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdRiepilogoDaFirmareDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdRiepilogoDaFirmareDownloadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce il richiedente di una richiesta
 * @summary Recupero richiedente della richiesta
 */
export const getFrontRichiesteIdRichiedente = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Utente>(
    {
      url: `/framework-cmp-domande/richieste/${id}/richiedente`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdRichiedenteQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/richiedente`] as const;

export const getGetFrontRichiesteIdRichiedenteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdRichiedenteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>
  > = ({ signal }) =>
    getFrontRichiesteIdRichiedente(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdRichiedenteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>
>;
export type GetFrontRichiesteIdRichiedenteQueryError = ErrorType<unknown>;

/**
 * @summary Recupero richiedente della richiesta
 */
export const useGetFrontRichiesteIdRichiedente = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdRichiedente>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdRichiedenteQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download del pdf della ricevuta di pagamento
 * @summary Download del pdf della ricevuta di pagamento
 */
export const getFrontRichiesteIdPagamentiIdRicevuta = (
  id: string,
  idPagamento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/ricevuta`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdPagamentiIdRicevutaQueryKey = (
  id: string,
  idPagamento: string,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/ricevuta`,
  ] as const;

export const getGetFrontRichiesteIdPagamentiIdRicevutaQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idPagamento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdPagamentiIdRicevutaQueryKey(id, idPagamento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>
  > = ({ signal }) =>
    getFrontRichiesteIdPagamentiIdRicevuta(
      id,
      idPagamento,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!(id && idPagamento), ...queryOptions };
};

export type GetFrontRichiesteIdPagamentiIdRicevutaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>
>;
export type GetFrontRichiesteIdPagamentiIdRicevutaQueryError =
  ErrorType<unknown>;

/**
 * @summary Download del pdf della ricevuta di pagamento
 */
export const useGetFrontRichiesteIdPagamentiIdRicevuta = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idPagamento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdRicevuta>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdPagamentiIdRicevutaQueryOptions(
    id,
    idPagamento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download del pdf dell'avviso di pagamento
 * @summary Download del pdf dell'avviso di pagamento (Modello 3)
 */
export const getFrontRichiesteIdPagamentiIdAvviso = (
  id: string,
  idPagamento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/avviso`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdPagamentiIdAvvisoQueryKey = (
  id: string,
  idPagamento: string,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/pagamenti/${idPagamento}/avviso`,
  ] as const;

export const getGetFrontRichiesteIdPagamentiIdAvvisoQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idPagamento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdPagamentiIdAvvisoQueryKey(id, idPagamento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>
  > = ({ signal }) =>
    getFrontRichiesteIdPagamentiIdAvviso(
      id,
      idPagamento,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!(id && idPagamento), ...queryOptions };
};

export type GetFrontRichiesteIdPagamentiIdAvvisoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>
>;
export type GetFrontRichiesteIdPagamentiIdAvvisoQueryError = ErrorType<unknown>;

/**
 * @summary Download del pdf dell'avviso di pagamento (Modello 3)
 */
export const useGetFrontRichiesteIdPagamentiIdAvviso = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idPagamento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdPagamentiIdAvviso>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdPagamentiIdAvvisoQueryOptions(
    id,
    idPagamento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce l’elenco di tutte le istanze di oneri associati a una domanda
 * @summary Recupero elenco oneri associati ad una domanda
 */
export const getFrontRichiesteIdOneri = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<OnereWithDettaglioDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/oneri`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdOneriQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/oneri`] as const;

export const getGetFrontRichiesteIdOneriQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdOneriQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>
  > = ({ signal }) => getFrontRichiesteIdOneri(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdOneriQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>
>;
export type GetFrontRichiesteIdOneriQueryError = ErrorType<unknown>;

/**
 * @summary Recupero elenco oneri associati ad una domanda
 */
export const useGetFrontRichiesteIdOneri = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdOneri>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdOneriQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dettaglio richiesta modulo di una richiesta
 * @summary Dettaglio richiesta modulo di una richiesta
 */
export const getFrontRichiesteIdModuloIdRichiestamodulo = (
  id: string,
  idModulo: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaModuloDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/modulo/${idModulo}/richiestamodulo`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdRichiestamoduloQueryKey = (
  id: string,
  idModulo: string,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/modulo/${idModulo}/richiestamodulo`,
  ] as const;

export const getGetFrontRichiesteIdModuloIdRichiestamoduloQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  idModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdRichiestamoduloQueryKey(id, idModulo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdRichiestamodulo(
      id,
      idModulo,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!(id && idModulo), ...queryOptions };
};

export type GetFrontRichiesteIdModuloIdRichiestamoduloQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>>
>;
export type GetFrontRichiesteIdModuloIdRichiestamoduloQueryError =
  ErrorType<unknown>;

/**
 * @summary Dettaglio richiesta modulo di una richiesta
 */
export const useGetFrontRichiesteIdModuloIdRichiestamodulo = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  idModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdRichiestamodulo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdModuloIdRichiestamoduloQueryOptions(
      id,
      idModulo,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Moduli associati ad una richiesta
 * @summary Moduli di una richiesta
 */
export const getFrontRichiesteIdModuli = (
  id: string,
  params?: GetFrontRichiesteIdModuliParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaModuloDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuliQueryKey = (
  id: string,
  params?: GetFrontRichiesteIdModuliParams,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/moduli`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdModuliQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdModuliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdModuliQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuli(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdModuliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>
>;
export type GetFrontRichiesteIdModuliQueryError = ErrorType<unknown>;

/**
 * @summary Moduli di una richiesta
 */
export const useGetFrontRichiesteIdModuli = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdModuliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuli>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdModuliQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dettaglio modulo di una richiesta
 * @summary Dettaglio modulo di una richiesta
 */
export const getFrontRichiesteIdModuliId = (
  id: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuliIdParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaModuloDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuliIdQueryKey = (
  id: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuliIdParams,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/moduli/${idRichiestaModulo}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdModuliIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuliIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuliIdQueryKey(id, idRichiestaModulo, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuliId(
      id,
      idRichiestaModulo,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(id && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuliIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>
>;
export type GetFrontRichiesteIdModuliIdQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio modulo di una richiesta
 */
export const useGetFrontRichiesteIdModuliId = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuliIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuliId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdModuliIdQueryOptions(
    id,
    idRichiestaModulo,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'elenco delle richieste integrate
 * @summary Elenco richieste integrate
 */
export const getFrontRichiesteIdIntegrate = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/integrate`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdIntegrateQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/integrate`] as const;

export const getGetFrontRichiesteIdIntegrateQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdIntegrateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>
  > = ({ signal }) => getFrontRichiesteIdIntegrate(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdIntegrateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>
>;
export type GetFrontRichiesteIdIntegrateQueryError = ErrorType<unknown>;

/**
 * @summary Elenco richieste integrate
 */
export const useGetFrontRichiesteIdIntegrate = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIntegrate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdIntegrateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce i soli dati del riepilogo non recuperabili autonomamente dal motore di riepilogo condiviso FrontOffice/BackOffice (nome competenza, moduli, e per il back office il nome del responsabile del procedimento)
 * @summary Dati aggiuntivi per il riepilogo della richiesta
 */
export const getFrontRichiesteIdDatiAggiuntiviRiepilogo = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<GetFrontRichiesteIdDatiAggiuntiviRiepilogo200>(
    {
      url: `/framework-cmp-domande/richieste/${id}/dati-aggiuntivi-riepilogo`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdDatiAggiuntiviRiepilogoQueryKey = (
  id: string,
) =>
  [`/framework-cmp-domande/richieste/${id}/dati-aggiuntivi-riepilogo`] as const;

export const getGetFrontRichiesteIdDatiAggiuntiviRiepilogoQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdDatiAggiuntiviRiepilogoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>>
  > = ({ signal }) =>
    getFrontRichiesteIdDatiAggiuntiviRiepilogo(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdDatiAggiuntiviRiepilogoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>>
>;
export type GetFrontRichiesteIdDatiAggiuntiviRiepilogoQueryError =
  ErrorType<unknown>;

/**
 * @summary Dati aggiuntivi per il riepilogo della richiesta
 */
export const useGetFrontRichiesteIdDatiAggiuntiviRiepilogo = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdDatiAggiuntiviRiepilogo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdDatiAggiuntiviRiepilogoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupera le competenze associate al tipo domanda di una richiesta
 * @summary Recupera le competenze associate al tipo domanda di una richiesta
 */
export const getFrontRichiesteIdCompetenze = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Competenza[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/competenze`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdCompetenzeQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/competenze`] as const;

export const getGetFrontRichiesteIdCompetenzeQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdCompetenzeQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>
  > = ({ signal }) => getFrontRichiesteIdCompetenze(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdCompetenzeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>
>;
export type GetFrontRichiesteIdCompetenzeQueryError = ErrorType<unknown>;

/**
 * @summary Recupera le competenze associate al tipo domanda di una richiesta
 */
export const useGetFrontRichiesteIdCompetenze = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdCompetenzeQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce le competenze secondarie di una richiesta
 * @summary Elenco competenze secondarie
 */
export const getFrontRichiesteIdCompetenzeSecondarie = (
  id: string,
  params?: GetFrontRichiesteIdCompetenzeSecondarieParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaCompetenzaSecondariaDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/competenze-secondarie`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdCompetenzeSecondarieQueryKey = (
  id: string,
  params?: GetFrontRichiesteIdCompetenzeSecondarieParams,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/competenze-secondarie`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdCompetenzeSecondarieQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdCompetenzeSecondarieParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdCompetenzeSecondarieQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>
  > = ({ signal }) =>
    getFrontRichiesteIdCompetenzeSecondarie(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdCompetenzeSecondarieQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>
>;
export type GetFrontRichiesteIdCompetenzeSecondarieQueryError =
  ErrorType<unknown>;

/**
 * @summary Elenco competenze secondarie
 */
export const useGetFrontRichiesteIdCompetenzeSecondarie = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdCompetenzeSecondarieParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarie>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdCompetenzeSecondarieQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce una competenza secondaria di una richiesta
 * @summary Dettaglio competenza secondaria
 */
export const getFrontRichiesteIdCompetenzeSecondarieId = (
  id: string,
  idCompetenzaSecondaria: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaCompetenzaSecondariaDTO>(
    {
      url: `/framework-cmp-domande/richieste/${id}/competenze-secondarie/${idCompetenzaSecondaria}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdCompetenzeSecondarieIdQueryKey = (
  id: string,
  idCompetenzaSecondaria: string,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/competenze-secondarie/${idCompetenzaSecondaria}`,
  ] as const;

export const getGetFrontRichiesteIdCompetenzeSecondarieIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idCompetenzaSecondaria: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdCompetenzeSecondarieIdQueryKey(
      id,
      idCompetenzaSecondaria,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>
  > = ({ signal }) =>
    getFrontRichiesteIdCompetenzeSecondarieId(
      id,
      idCompetenzaSecondaria,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(id && idCompetenzaSecondaria),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdCompetenzeSecondarieIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>
>;
export type GetFrontRichiesteIdCompetenzeSecondarieIdQueryError =
  ErrorType<unknown>;

/**
 * @summary Dettaglio competenza secondaria
 */
export const useGetFrontRichiesteIdCompetenzeSecondarieId = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  idCompetenzaSecondaria: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCompetenzeSecondarieId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdCompetenzeSecondarieIdQueryOptions(
    id,
    idCompetenzaSecondaria,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'elenco dei collegamenti di una richiesta
 * @summary Elenco collegamenti di una richiesta
 */
export const getFrontRichiesteIdCollegamenti = (
  id: string,
  params?: GetFrontRichiesteIdCollegamentiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CollegamentoRichiestaDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/collegamenti`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdCollegamentiQueryKey = (
  id: string,
  params?: GetFrontRichiesteIdCollegamentiParams,
) =>
  [
    `/framework-cmp-domande/richieste/${id}/collegamenti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdCollegamentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdCollegamentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdCollegamentiQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>
  > = ({ signal }) =>
    getFrontRichiesteIdCollegamenti(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdCollegamentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>
>;
export type GetFrontRichiesteIdCollegamentiQueryError = ErrorType<unknown>;

/**
 * @summary Elenco collegamenti di una richiesta
 */
export const useGetFrontRichiesteIdCollegamenti = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteIdCollegamentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdCollegamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdCollegamentiQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupera i dettagli sugli allegati di una richiesta
 * @summary Recupera i dettagli sugli allegati di una richiesta
 */
export const getFrontRichiesteIdAllegati = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AllegatoRichiestaDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${id}/allegati`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdAllegatiQueryKey = (id: string) =>
  [`/framework-cmp-domande/richieste/${id}/allegati`] as const;

export const getGetFrontRichiesteIdAllegatiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteIdAllegatiQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>
  > = ({ signal }) => getFrontRichiesteIdAllegati(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteIdAllegatiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>
>;
export type GetFrontRichiesteIdAllegatiQueryError = ErrorType<unknown>;

/**
 * @summary Recupera i dettagli sugli allegati di una richiesta
 */
export const useGetFrontRichiesteIdAllegati = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdAllegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdAllegatiQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFrontRichiesteIdIsDeletable = (
  idTagSemantico: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-cmp-domande/richieste/${idTagSemantico}/isDeletable`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdIsDeletableQueryKey = (
  idTagSemantico: string,
) =>
  [`/framework-cmp-domande/richieste/${idTagSemantico}/isDeletable`] as const;

export const getGetFrontRichiesteIdIsDeletableQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdIsDeletableQueryKey(idTagSemantico);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>
  > = ({ signal }) =>
    getFrontRichiesteIdIsDeletable(idTagSemantico, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idTagSemantico, ...queryOptions };
};

export type GetFrontRichiesteIdIsDeletableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>
>;
export type GetFrontRichiesteIdIsDeletableQueryError = ErrorType<unknown>;

export const useGetFrontRichiesteIdIsDeletable = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdIsDeletableQueryOptions(
    idTagSemantico,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFrontRichiesteIdIndirizziPostaElettronica = (
  idRichiesta: string,
  tipoComunicazioneDestinatarioDTO: TipoComunicazioneDestinatarioDTO[],
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/indirizzi-posta-elettronica`,
      method: 'get',
      headers: { 'Content-Type': 'application/json' },
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdIndirizziPostaElettronicaQueryKey = (
  idRichiesta: string,
  tipoComunicazioneDestinatarioDTO: TipoComunicazioneDestinatarioDTO[],
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/indirizzi-posta-elettronica`,
    tipoComunicazioneDestinatarioDTO,
  ] as const;

export const getGetFrontRichiesteIdIndirizziPostaElettronicaQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  tipoComunicazioneDestinatarioDTO: TipoComunicazioneDestinatarioDTO[],
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdIndirizziPostaElettronicaQueryKey(
      idRichiesta,
      tipoComunicazioneDestinatarioDTO,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>>
  > = ({ signal }) =>
    getFrontRichiesteIdIndirizziPostaElettronica(
      idRichiesta,
      tipoComunicazioneDestinatarioDTO,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!idRichiesta, ...queryOptions };
};

export type GetFrontRichiesteIdIndirizziPostaElettronicaQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>>
  >;
export type GetFrontRichiesteIdIndirizziPostaElettronicaQueryError =
  ErrorType<unknown>;

export const useGetFrontRichiesteIdIndirizziPostaElettronica = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  tipoComunicazioneDestinatarioDTO: TipoComunicazioneDestinatarioDTO[],
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIndirizziPostaElettronica>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdIndirizziPostaElettronicaQueryOptions(
      idRichiesta,
      tipoComunicazioneDestinatarioDTO,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Genera lo schema idratato di una richiesta, ovvero la struttura con i campi valorizzati.
 */
export const getFrontRichiesteIdIdratata = (
  idRichiesta: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaIdratataDTO>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/idratata`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdIdratataQueryKey = (idRichiesta: string) =>
  [`/framework-cmp-domande/richieste/${idRichiesta}/idratata`] as const;

export const getGetFrontRichiesteIdIdratataQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdIdratataQueryKey(idRichiesta);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>
  > = ({ signal }) =>
    getFrontRichiesteIdIdratata(idRichiesta, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idRichiesta, ...queryOptions };
};

export type GetFrontRichiesteIdIdratataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>
>;
export type GetFrontRichiesteIdIdratataQueryError = ErrorType<unknown>;

/**
 * @summary Genera lo schema idratato di una richiesta, ovvero la struttura con i campi valorizzati.
 */
export const useGetFrontRichiesteIdIdratata = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdIdratata>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdIdratataQueryOptions(
    idRichiesta,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getFrontRichiesteIdElencoFile = (
  idRichiesta: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ElencoFileDocumento[]>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/elenco-file`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdElencoFileQueryKey = (idRichiesta: string) =>
  [`/framework-cmp-domande/richieste/${idRichiesta}/elenco-file`] as const;

export const getGetFrontRichiesteIdElencoFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdElencoFileQueryKey(idRichiesta);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>
  > = ({ signal }) =>
    getFrontRichiesteIdElencoFile(idRichiesta, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idRichiesta, ...queryOptions };
};

export type GetFrontRichiesteIdElencoFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>
>;
export type GetFrontRichiesteIdElencoFileQueryError = ErrorType<unknown>;

export const useGetFrontRichiesteIdElencoFile = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdElencoFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdElencoFileQueryOptions(
    idRichiesta,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Scarica un allegato della richiesta dato l'ID della richiesta e l'ID dell'allegato. L'utente deve avere permesso di lettura sull'allegato (come per GET allegati).
 * @summary Scarica un allegato per ID
 */
export const getFrontRichiesteIdAllegatiIdDownload = (
  idRichiesta: string,
  idAllegato: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/allegati/${idAllegato}/download`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdAllegatiIdDownloadQueryKey = (
  idRichiesta: string,
  idAllegato: string,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/allegati/${idAllegato}/download`,
  ] as const;

export const getGetFrontRichiesteIdAllegatiIdDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>,
  TError = ErrorType<WsProblema>,
>(
  idRichiesta: string,
  idAllegato: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdAllegatiIdDownloadQueryKey(idRichiesta, idAllegato);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>
  > = ({ signal }) =>
    getFrontRichiesteIdAllegatiIdDownload(
      idRichiesta,
      idAllegato,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idAllegato),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdAllegatiIdDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>
>;
export type GetFrontRichiesteIdAllegatiIdDownloadQueryError =
  ErrorType<WsProblema>;

/**
 * @summary Scarica un allegato per ID
 */
export const useGetFrontRichiesteIdAllegatiIdDownload = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>,
  TError = ErrorType<WsProblema>,
>(
  idRichiesta: string,
  idAllegato: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdAllegatiIdDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdAllegatiIdDownloadQueryOptions(
    idRichiesta,
    idAllegato,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Ritorna l’elenco dei Moduli (ModuloDto) associati alle richieste del procedimento
 */
export const getFrontRichiesteIdTipiModuli = (
  idRichiestaOriginale: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ModuloDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiestaOriginale}/tipi-moduli`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdTipiModuliQueryKey = (
  idRichiestaOriginale: string,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiestaOriginale}/tipi-moduli`,
  ] as const;

export const getGetFrontRichiesteIdTipiModuliQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>,
  TError = ErrorType<unknown>,
>(
  idRichiestaOriginale: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdTipiModuliQueryKey(idRichiestaOriginale);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>
  > = ({ signal }) =>
    getFrontRichiesteIdTipiModuli(idRichiestaOriginale, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idRichiestaOriginale,
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdTipiModuliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>
>;
export type GetFrontRichiesteIdTipiModuliQueryError = ErrorType<unknown>;

/**
 * @summary Ritorna l’elenco dei Moduli (ModuloDto) associati alle richieste del procedimento
 */
export const useGetFrontRichiesteIdTipiModuli = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>,
  TError = ErrorType<unknown>,
>(
  idRichiestaOriginale: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdTipiModuli>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdTipiModuliQueryOptions(
    idRichiestaOriginale,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero dei dati di ogni sezione per ogni modulo relativo ad una richiesta
 */
export const getFrontRichiesteValoriSezioniProcedimentoId = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<unknown[]>(
    {
      url: `/framework-cmp-domande/richieste/valori-sezioni/procedimento/${idIstanzaProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteValoriSezioniProcedimentoIdQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-cmp-domande/richieste/valori-sezioni/procedimento/${idIstanzaProcedimento}`,
  ] as const;

export const getGetFrontRichiesteValoriSezioniProcedimentoIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteValoriSezioniProcedimentoIdQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>>
  > = ({ signal }) =>
    getFrontRichiesteValoriSezioniProcedimentoId(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetFrontRichiesteValoriSezioniProcedimentoIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>>
  >;
export type GetFrontRichiesteValoriSezioniProcedimentoIdQueryError =
  ErrorType<unknown>;

export const useGetFrontRichiesteValoriSezioniProcedimentoId = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteValoriSezioniProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteValoriSezioniProcedimentoIdQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dettaglio della richiesta per idIstanzaProcedimento.
 * @summary Dettaglio richiesta
 */
export const getFrontRichiesteProcedimentoId = (
  idIstanzaProcedimento: string,
  params?: GetFrontRichiesteProcedimentoIdParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/procedimento/${idIstanzaProcedimento}`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteProcedimentoIdQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetFrontRichiesteProcedimentoIdParams,
) =>
  [
    `/framework-cmp-domande/richieste/procedimento/${idIstanzaProcedimento}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteProcedimentoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetFrontRichiesteProcedimentoIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteProcedimentoIdQueryKey(idIstanzaProcedimento, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>
  > = ({ signal }) =>
    getFrontRichiesteProcedimentoId(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetFrontRichiesteProcedimentoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>
>;
export type GetFrontRichiesteProcedimentoIdQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio richiesta
 */
export const useGetFrontRichiesteProcedimentoId = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetFrontRichiesteProcedimentoIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteProcedimentoIdQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero delle mappe geografiche di ogni sezione per ogni modulo relativo ad una richiesta
 */
export const getFrontRichiesteMappeSezioniProcedimentoId = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<MappaGeografica[]>(
    {
      url: `/framework-cmp-domande/richieste/mappe-sezioni/procedimento/${idIstanzaProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteMappeSezioniProcedimentoIdQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-cmp-domande/richieste/mappe-sezioni/procedimento/${idIstanzaProcedimento}`,
  ] as const;

export const getGetFrontRichiesteMappeSezioniProcedimentoIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteMappeSezioniProcedimentoIdQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>>
  > = ({ signal }) =>
    getFrontRichiesteMappeSezioniProcedimentoId(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetFrontRichiesteMappeSezioniProcedimentoIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>>
  >;
export type GetFrontRichiesteMappeSezioniProcedimentoIdQueryError =
  ErrorType<unknown>;

export const useGetFrontRichiesteMappeSezioniProcedimentoId = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteMappeSezioniProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteMappeSezioniProcedimentoIdQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupera i dettagli sugli allegati richiesta di un Istanza Procedimento
 * @summary Recupera i dettagli sugli allegati richiesta di un Istanza Procedimento
 */
export const getFrontRichiesteIstanzaProcedimentoIdAllegati = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AllegatoRichiestaDTO[]>(
    {
      url: `/framework-cmp-domande/richieste/istanza-procedimento/${idIstanzaProcedimento}/allegati`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIstanzaProcedimentoIdAllegatiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-cmp-domande/richieste/istanza-procedimento/${idIstanzaProcedimento}/allegati`,
  ] as const;

export const getGetFrontRichiesteIstanzaProcedimentoIdAllegatiQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIstanzaProcedimentoIdAllegatiQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>>
  > = ({ signal }) =>
    getFrontRichiesteIstanzaProcedimentoIdAllegati(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetFrontRichiesteIstanzaProcedimentoIdAllegatiQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>>
  >;
export type GetFrontRichiesteIstanzaProcedimentoIdAllegatiQueryError =
  ErrorType<unknown>;

/**
 * @summary Recupera i dettagli sugli allegati richiesta di un Istanza Procedimento
 */
export const useGetFrontRichiesteIstanzaProcedimentoIdAllegati = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIstanzaProcedimentoIdAllegati>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIstanzaProcedimentoIdAllegatiQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero tutti i campi potenzialmente estraibili in geogson per tutti i tipi di richiesta/domanda (per verticale)
 */
export const getFrontRichiesteGeojsonCampi = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-cmp-domande/richieste/geojson/campi`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteGeojsonCampiQueryKey = () =>
  [`/framework-cmp-domande/richieste/geojson/campi`] as const;

export const getGetFrontRichiesteGeojsonCampiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteGeojsonCampiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>
  > = ({ signal }) => getFrontRichiesteGeojsonCampi(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontRichiesteGeojsonCampiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>
>;
export type GetFrontRichiesteGeojsonCampiQueryError = ErrorType<unknown>;

export const useGetFrontRichiesteGeojsonCampi = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontRichiesteGeojsonCampi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteGeojsonCampiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Tag semantici della richiesta filtrati per nome
 */
export const getFrontRichiesteEstraiCampiSemantici = (
  params: GetFrontRichiesteEstraiCampiSemanticiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoSemantico[]>(
    {
      url: `/framework-cmp-domande/richieste/estraiCampiSemantici`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteEstraiCampiSemanticiQueryKey = (
  params: GetFrontRichiesteEstraiCampiSemanticiParams,
) =>
  [
    `/framework-cmp-domande/richieste/estraiCampiSemantici`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteEstraiCampiSemanticiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>,
  TError = ErrorType<unknown>,
>(
  params: GetFrontRichiesteEstraiCampiSemanticiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteEstraiCampiSemanticiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>
  > = ({ signal }) =>
    getFrontRichiesteEstraiCampiSemantici(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontRichiesteEstraiCampiSemanticiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>
>;
export type GetFrontRichiesteEstraiCampiSemanticiQueryError =
  ErrorType<unknown>;

/**
 * @summary Tag semantici della richiesta filtrati per nome
 */
export const useGetFrontRichiesteEstraiCampiSemantici = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>,
  TError = ErrorType<unknown>,
>(
  params: GetFrontRichiesteEstraiCampiSemanticiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteEstraiCampiSemantici>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteEstraiCampiSemanticiQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero tutti i campi potenzialmente estraibili in csv per tutti i tipi di richiesta/domanda (per verticale)
 */
export const getFrontRichiesteCsvCampi = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-cmp-domande/richieste/csv/campi`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteCsvCampiQueryKey = () =>
  [`/framework-cmp-domande/richieste/csv/campi`] as const;

export const getGetFrontRichiesteCsvCampiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteCsvCampiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>
  > = ({ signal }) => getFrontRichiesteCsvCampi(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontRichiesteCsvCampiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>
>;
export type GetFrontRichiesteCsvCampiQueryError = ErrorType<unknown>;

export const useGetFrontRichiesteCsvCampi = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontRichiesteCsvCampi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteCsvCampiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dettaglio della richiesta, visibile solo da un utente che è compilatore e/o delagato della richiestas
 * @summary Dettaglio richiesta
 */
export const getFrontRichiesteByIdIstanzaProcedimentoId = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/byIdIstanzaProcedimento/${idIstanzaProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteByIdIstanzaProcedimentoIdQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-cmp-domande/richieste/byIdIstanzaProcedimento/${idIstanzaProcedimento}`,
  ] as const;

export const getGetFrontRichiesteByIdIstanzaProcedimentoIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteByIdIstanzaProcedimentoIdQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>>
  > = ({ signal }) =>
    getFrontRichiesteByIdIstanzaProcedimentoId(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetFrontRichiesteByIdIstanzaProcedimentoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>>
>;
export type GetFrontRichiesteByIdIstanzaProcedimentoIdQueryError =
  ErrorType<unknown>;

/**
 * @summary Dettaglio richiesta
 */
export const useGetFrontRichiesteByIdIstanzaProcedimentoId = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteByIdIstanzaProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteByIdIstanzaProcedimentoIdQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Dettaglio della richiesta per idIstanzaProcedimento.
 * @summary Dettaglio richiesta by uuid
 */
export const getFrontRichiesteB2BByCuiId = (
  cuiUuid: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RichiestaDTO>(
    {
      url: `/framework-cmp-domande/richieste/b2b/by-cui/${cuiUuid}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteB2BByCuiIdQueryKey = (cuiUuid: string) =>
  [`/framework-cmp-domande/richieste/b2b/by-cui/${cuiUuid}`] as const;

export const getGetFrontRichiesteB2BByCuiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>,
  TError = ErrorType<unknown>,
>(
  cuiUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontRichiesteB2BByCuiIdQueryKey(cuiUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>
  > = ({ signal }) =>
    getFrontRichiesteB2BByCuiId(cuiUuid, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!cuiUuid, ...queryOptions };
};

export type GetFrontRichiesteB2BByCuiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>
>;
export type GetFrontRichiesteB2BByCuiIdQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio richiesta by uuid
 */
export const useGetFrontRichiesteB2BByCuiId = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>,
  TError = ErrorType<unknown>,
>(
  cuiUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteB2BByCuiId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteB2BByCuiIdQueryOptions(
    cuiUuid,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Elimina allegati  e richieste in sospeso da piu di 24H
 * @summary Elimina orfani
 */
export const deleteFrontRichiesteEliminaOrfani = (
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SchedulationResult>(
    { url: `/framework-cmp-domande/richieste/eliminaOrfani`, method: 'delete' },
    options,
  );
};

export const getDeleteFrontRichiesteEliminaOrfaniMutationOptions = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteEliminaOrfani>>,
    TError,
    TVariables,
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFrontRichiesteEliminaOrfani>>,
  TError,
  TVariables,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFrontRichiesteEliminaOrfani>>,
    TVariables
  > = () => {
    return deleteFrontRichiesteEliminaOrfani(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFrontRichiesteEliminaOrfaniMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFrontRichiesteEliminaOrfani>>
>;

export type DeleteFrontRichiesteEliminaOrfaniMutationError = ErrorType<unknown>;

/**
 * @summary Elimina orfani
 */
export const useDeleteFrontRichiesteEliminaOrfani = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFrontRichiesteEliminaOrfani>>,
    TError,
    TVariables,
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteFrontRichiesteEliminaOrfaniMutationOptions(options);

  return useMutation(mutationOptions);
};
